import { SET_IMPERSONATION_ACTIVE } from "../actions/types";

const initialState = {
  active: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IMPERSONATION_ACTIVE:
      return { ...state, active: Boolean(action.payload) };
    default:
      return state;
  }
};
